// extracted by mini-css-extract-plugin
module.exports = {"item":"promotion_item___mC8n","percent":"promotion_percent__5YI6u","percentLeft":"promotion_percentLeft__hVR_x","img":"promotion_img__firbC","title":"promotion_title__C2trA"};